import { InlineAlert } from '@xo-union/tk-component-alerts';
import React from 'react';
import { Link } from 'react-router-dom';

import { useWeddingWebsiteQuery } from '../generated/graphql';
import { purchaseDomainRenewalRoute } from '../helpers/routes';

const CustomDomainExpirationAlert: React.FC = () => {
  const { data } = useWeddingWebsiteQuery();
  if (data?.weddingWebsite.purchaseDomain?.showRenewal) {
    return (
      <div data-testid="custom-domain-expiration-alert">
        <InlineAlert type="error">
          Your domain is about to expire, renew <Link to={purchaseDomainRenewalRoute}>here</Link>
        </InlineAlert>
      </div>
    );
  }

  return null;
};

export default CustomDomainExpirationAlert;
